import * as React from "react"
import Image from "gatsby-image"

// Styles
import "./_inset-image.scss"

// Components
import { Container } from "../StyledComponents/layoutComponentStyles"

interface InsetImageProps {
  module: any
}

/*









*/

const InsetImage: React.FunctionComponent<InsetImageProps> = ({ module }) => {
  return (
    <Container sixteenClm>
      <div className='project-img__contained'>
        {module.image.image.asset.extension === "gif" ? (
          <img src={module.image.image.asset.url} alt={module.image.altText} className='project-img-contained__asset' />
        ) : (
          <Image
            fluid={module.image.image.asset.fluid}
            alt={module.image.altText}
            style={{ height: "inherit" }}
            className='project-img-contained__asset'
          />
        )}
      </div>
    </Container>
  )
}

export default InsetImage
